import script from "./ContactView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactView.vue?vue&type=script&setup=true&lang=js"

import "./ContactView.vue?vue&type=style&index=0&id=2cdf6399&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cdf6399"]])

export default __exports__